import React from 'react';

import { PACKAGE_HOME_PATH } from '../../../../store/constants';

import RedirectToPage from '../../../../components/RedirectToPage';
import Payment from '../../../../components/Payment';
import Services from '../../containers/Services';

import type { PropsFromRedux } from '.';
import { Container } from '../../../../routes/styles';

export const ServicesRoute = (props: PropsFromRedux) => {
  const { redirectToHome, isCreated, isMobile } = props;

  if (redirectToHome) {
    return <RedirectToPage path={PACKAGE_HOME_PATH} />;
  }

  return (
    <>
      {!isCreated && (
        <Container $isMobile={isMobile}>
          <Services />
        </Container>
      )}

      <Container $isMobile={isMobile}>
        <Payment />
      </Container>
    </>
  );
};
